import { render, staticRenderFns } from "./m_videoPriceDetail.vue?vue&type=template&id=a19ba708&scoped=true&"
import script from "./m_videoPriceDetail.vue?vue&type=script&lang=js&"
export * from "./m_videoPriceDetail.vue?vue&type=script&lang=js&"
import style0 from "./m_videoPriceDetail.vue?vue&type=style&index=0&id=a19ba708&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19ba708",
  null
  
)

export default component.exports